import { useState } from 'react';

/**
 * Mobile navigation history management
 * Extracted from EditorPage.js
 * Handles back/forward navigation for mobile view
 */
export function useMobileNavigation() {
  const [history, setHistory] = useState([]);
  const [historyIndex, setHistoryIndex] = useState(-1);

  const addToHistory = (file) => {
    const newHistory = history.slice(0, historyIndex + 1);
    newHistory.push(file);
    setHistory(newHistory);
    setHistoryIndex(newHistory.length - 1);
  };

  const goBack = () => {
    if (historyIndex > 0) {
      const newIndex = historyIndex - 1;
      setHistoryIndex(newIndex);
      return history[newIndex];
    }
    return null;
  };

  const goForward = () => {
    if (historyIndex < history.length - 1) {
      const newIndex = historyIndex + 1;
      setHistoryIndex(newIndex);
      return history[newIndex];
    }
    return null;
  };

  const canGoBack = historyIndex > 0;
  const canGoForward = historyIndex < history.length - 1;

  return {
    addToHistory,
    goBack,
    goForward,
    canGoBack,
    canGoForward
  };
}
